module.exports = __webpack_public_path__ + "img/1-1ZR1163Z0T3.e1c4cc1c.jpeg";